import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

    errorMsgBox: () => {
        const styles = {
            display: 'flex',
            flexDirection: 'column !important',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            maxWidth: '464px',
            border: '1px solid #B3261E',
            borderRadius: '8px',
            background: '#B3261E26',
            padding: '8px',
            margin: '4px 0px',

            [theme.breakpoints.down('xs')]: {
                width: 'calc(100% - 16px)',
            },
        };

        return styles;
    },

    errorMessageTitleContainer: () => {
        const styles = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        };

        return styles;
    },

    errorMessageTitleIcon: () => {
        const styles = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '6px',
        };

        return styles;
    },

    bannerImage: () => {
        const styles = {
            width: '13px',
            height: '13px',
            marginTop: '-1px',
        };

        return styles;
    },

    errorMessageTitleText: () => { 
        const styles = {
            fontSize: '14px',
            color: '#B3261E',
            lineHeight: '20px',
            fontWeight: '350',
        };

        return styles;
    },

    errorMessageMessageContainer: () => {
        const styles = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            margin: '2px 0px',
        };

        return styles;
    },

    errorMessageMessageText: () => {
        const styles = {
            fontSize: '12px',
            color: '#0C0644',
            lineHeight: '20px',
            textAlign: 'center',
            padding: '0px 8px',
            margin: '0px',
        };

        return styles;
    },

    errorMessageRefId: () => {
        const styles = {
            fontSize: '10px',
            color: '#0C0644',
            lineHeight: '20px',
            textAlign: 'center',
        };

        return styles;
    },

});

export default styles;
export const useStyles = makeStyles(styles);
